import React from 'react';
import { Skeleton } from '@mui/material';
import NoResultCard from '../../common/NoResultCard.jsx';
import FrameworkAgreementsListCard from './FrameworkAgreementsListCard.jsx';

const FrameworkAgreementsList = ({
    context,
    societesId,
    membresId,
    loading,
    frameworkAgreements,
}) => {

    return (
        <div id="framework_agreements-list">
            {loading ? (
                <div className="row">
                    {Array(5).fill(0).map((e, index) => 
                        <div key={index} className="col-12 mb-3">
                            <Skeleton className="card bg-gc-light-blue-dark border-none" variant="rectangular" width="100%" height={212} />
                        </div>
                    )}
                </div>
            ) : (
                <div className="row">
                    {
                        frameworkAgreements.length ?
                            frameworkAgreements.map((frameworkAgreement, i) => (
                                <FrameworkAgreementsListCard
                                    key={i}
                                    context={context}
                                    frameworkAgreement={frameworkAgreement}
                                    showActionButton={true}
                                />
                            ))
                        :
                        <NoResultCard />
                    }
                </div>
            )}
        </div>
    );

}

export default FrameworkAgreementsList;
